import React, { useEffect, useState } from 'react';
import _ from 'lodash';
export const StepperInput = ({ name, options, value, error, onblur, onchange }) => {
    const [stepperValue, setStepperValue] = useState(value);
    useEffect(() => setStepperValue(value), [value]);
    const onChange = (newValue) => {
        if (onchange) {
            onchange(undefined, newValue);
        }
        else {
            setStepperValue(newValue);
        }
    };
    return (React.createElement("div", { className: "stepper" },
        React.createElement("div", { className: `btn-group btn-block btn-darken ${error ? 'invalid' : ''}` }, _.map(options || [], (o, i) => (React.createElement("button", { key: `btn-${name}-${i}`, id: `btn-${name}-${i}`, className: `btn ${(o.value === stepperValue) ? 'btn-dark btn-active' : 'btn-link'}`, onClick: () => onChange(o.value), onBlur: onblur, type: "button", disabled: o.disabled }, o.label || o.value))))));
};
//# sourceMappingURL=Stepper.js.map